import React, { useState, useEffect } from 'react';
import { TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box, Grid, TablePagination, Button } from '@mui/material';
import axios from 'axios';
import swal from 'sweetalert';
import { Verified } from '@mui/icons-material';
import { useDeadline } from "../../../../contexts/DeadlineContext";
import { useHistory } from "react-router-dom";

const AffiliationCparticipantReport = () => {
  const history = useHistory();
  const [searchTerm, setSearchTerm] = useState('');
  const { offButton, abstractHomeSetup, getAbstractDeadLineStatus } = useDeadline();
  const [participantIndex, setParticipantIndex] = useState([]);
  const [totalBadges, setTotalBadges] = useState(0);
  const [filteredParticipants, setFilteredParticipants] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [totalRecords, setTotalRecords] = useState(0);
  const [filteredRecordsCount, setFilteredRecordsCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [permissions, setrPermissions] = useState([]);
  const eventid = localStorage.getItem('eventid');
  const gradientBackground = '#05597D';
  const [VerifiedPaymentsCount, setVerifiedPaymentsCount] = useState(0);
  const [PendingPaymentsCount, setPendingPaymentsCount] = useState(0);
  React.useEffect(() => {
    axios.get(`api/getpermissionByRole`).then(res => {

      if (res.status === 200) {
        const datad = res.data.data.permissions;
        setrPermissions(datad)
      } else {

      }
    })

  }, []);

  useEffect(() => {
    axios.get(`api/conference-particpant-indexAffiliation?id=${eventid}`)
      .then(res => {
        if (res.status === 200) {
          const data = res.data.cpindex;
          const totalBadgeReports = data.reduce((total, item) => total + (Array.isArray(item.cpbadge_report) ? item.cpbadge_report.length : 0), 0);

          // Count verified payments (status = 1)
          const verifiedPaymentsCount = data.filter(item =>
            Array.isArray(item.cppyament) &&
            item.cppyament.some(payment => payment.status === 1)
          ).length;

          // Count verified payments (status = 1)
          const pendingPaymentsCount = data.filter(item =>
            Array.isArray(item.cppyament) &&
            item.cppyament.some(payment => payment.status === 0)
          ).length;

          setVerifiedPaymentsCount(verifiedPaymentsCount);
          setPendingPaymentsCount(pendingPaymentsCount);
          setTotalBadges(totalBadgeReports);
          setParticipantIndex(data);
          setTotalRecords(data.length);
        } else {
          swal('Error', "Check API Something Wrong", 'error');
        }
      })
      .catch(error => {
        swal('Error', "Failed to fetch participants data", 'error');
      });
  }, [eventid]);

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  useEffect(() => {
    if (selectedDate) {
      const filtered = participantIndex.filter(participant => {
        const participantDate = new Date(participant.created_at);
        const selectedDateObj = new Date(selectedDate);
        return participantDate.toDateString() === selectedDateObj.toDateString();
      });
      setFilteredParticipants(filtered);
      setFilteredRecordsCount(filtered.length);
    } else {
      setFilteredParticipants(participantIndex);
      setFilteredRecordsCount(participantIndex.length);
    }
  }, [selectedDate, participantIndex]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const value = event.target.value === 'All' ? filteredRecordsCount : parseInt(event.target.value, 10);
    setRowsPerPage(value);
    setPage(0);
  };

  const convertToCSV = (dataFromDownloadCSV) => {
    const header = ['#', 'QrCode Id', 'Name', 'Email', 'Mobile No', 'Saudi Council No', 'Conference', 'Registered Date', 'Time', 'Status', 'Verify', 'Printed Badges'];

    const rows = dataFromDownloadCSV.map((participant, index) => {
      const badgeCount = participant.cpbadge_report ? participant.cpbadge_report.length : 0;
      const badgeTimes = badgeCount > 0
        ? participant.cpbadge_report.map(badge => new Date(badge.created_at).toLocaleString()).join("\r\n")
        : "N/A";

      return [
        index + 1 + page * rowsPerPage,
        participant.id,
        participant.participant_name,
        participant.participant_email,
        participant.participant_phone_number,
        participant.participant_saudi_council_no,
        participant.cpcategory.conference_category_title,
        new Date(participant.created_at).toLocaleString(),
        participant.cppyament && participant.cppyament.length > 0
          ? participant.cppyament[0].status === 1
            ? "Verified"
            : "Pending"
          : "No Payment",
        `"${participant.cpconference.length > 0
          ? participant.cpconference.map((conf) => conf.verified_by_name).join(", ")
          : "Auto Verified"}"`,
        `"${badgeCount} Badges\r\n${badgeTimes}"`,
      ];
    });

    const csvContent = [header, ...rows].map(row => row.join(',')).join('\n');
    return csvContent;
  };


  const downloadCSV = () => {
    const csvContent = convertToCSV(filteredParticipants);
    const eventName = filteredParticipants[0]?.cpcategory?.event_name || 'conference_report';
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${eventName}.csv`;
    link.click();
  };
  return (
    <div style={{ margin: '1%', width: '100vw', marginLeft: '0%' }}>
      <Box sx={{ color: '#000000', marginTop: '5%' }}>
        <Button sx={{
                    float: 'right',
                    marginTop: '2%',
                    background: abstractHomeSetup.color_code_two || gradientBackground,
                    ":hover": {
                      color: "white"
                    }
                  }}
                    color='success'
                    size='small'
                    variant='contained'
                    
                    onClick={() => history.goBack()} >
                    Back
                  </Button>
        <Typography variant="h5" sx={{ color: '#000000', marginLeft: '1%' }}>
           Affiliation Conference Participant Daily Report
        </Typography>
        <Typography sx={{ color: '#000000', marginLeft: '1%' }}>
          Total Records: {totalRecords} | Filtered Records: {filteredRecordsCount}
        </Typography>
        <Typography sx={{ color: '#000000', marginLeft: '1%' }}>
          Total Printed Badges: {totalBadges}
        </Typography>
        <Typography sx={{ color: '#000000', marginLeft: '1%' }}>
          Verified Participant: {VerifiedPaymentsCount} | Pending Participant: {PendingPaymentsCount}
        </Typography>
        <Grid container spacing={2} alignItems="center" justifyContent="flex-end">
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Filter By: Name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Filter By: Date"
              type="date"
              value={selectedDate}
              onChange={handleDateChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
        {
          permissions['p_conference-report-download'] === true ?
            <Button
              variant="contained"
              color="primary"
              onClick={downloadCSV}
              sx={{
                marginTop: '1rem',
                float: 'right',
                background: abstractHomeSetup.color_code_two || gradientBackground,
              }}
            >
              Download CSV
            </Button> : ""
        }
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell align="left">QrCode Id</TableCell>
                <TableCell align="left">Name</TableCell>
                <TableCell align="left">Email</TableCell>
                <TableCell align="left">Mobile No</TableCell>
                <TableCell align="left">Saudi Council No</TableCell>
                <TableCell align="left">Conference</TableCell>
                <TableCell align="left">Registered Date And Time</TableCell>
                <TableCell align="left">Status</TableCell>
                <TableCell align="left">Verified By</TableCell>
                <TableCell align="left">Printed Badges</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredParticipants
                .filter(participant =>
                  participant.participant_name.toLowerCase().includes(searchTerm.toLowerCase())
                )
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((participant, index) => {
                  const badgeCount = participant.cpbadge_report ? participant.cpbadge_report.length : 0;
                  const badgeTimes = badgeCount > 0
                    ? participant.cpbadge_report.map(badge => (
                      <span key={badge.id}>
                        {new Date(badge.created_at).toLocaleString()} <br />
                      </span>
                    ))
                    : "N/A";
                  return (
                    <TableRow key={participant.id}>
                      <TableCell>{index + 1 + page * rowsPerPage}</TableCell>
                      <TableCell align="left">{participant.id}</TableCell>
                      <TableCell align="left">{participant.participant_name}</TableCell>
                      <TableCell align="left">{participant.participant_email}</TableCell>
                      <TableCell align="left">{participant.participant_phone_number}</TableCell>
                      <TableCell align="left">{participant.participant_saudi_council_no}</TableCell>
                      <TableCell align="left">{participant.cpcategory.conference_category_title}</TableCell>
                      <TableCell align="left">{new Date(participant.created_at).toLocaleString()}</TableCell>
                      <TableCell align="left">
                        {participant.cppyament && participant.cppyament.length > 0
                          ? participant.cppyament[0].status === 1
                            ? "Verified"
                            : "Pending"
                          : "No Payment"}
                      </TableCell>
                   
                      <TableCell align="left">
                        {participant.cpconference.length > 0
                          ? participant.cpconference.map((conf) => conf.verified_by_name).join(", ")
                          : participant.cppyament && participant.cppyament.length > 0 && participant.cppyament[0].status === 1
                            ? "Auto Verified"
                            : "Waiting for Verify"}
                      </TableCell>
                      <TableCell align="left">
                        {badgeCount} Badges <br />
                        {badgeTimes}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 'All']}
          component="div"
          count={filteredRecordsCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </div>
  );
}

export default AffiliationCparticipantReport;
